import React from 'react';
import { getDisplayName } from 'utils/misc';
import {
  getRequestedPath,
  getSideBarOpenPreference,
} from 'utils/userPreferences';

//a HOC component to pass local storage data as props to component
const withUserData = (WrappedComponent) => {
  const WithUserData = (props) => {
    const currentPath = getRequestedPath();
    const sideBarOpen = getSideBarOpenPreference();

    return (
      <WrappedComponent userData={{ currentPath, sideBarOpen }} {...props} />
    );
  };
  WithUserData.displayName = `WithUserData(${getDisplayName(
    WrappedComponent
  )})`;
  return WithUserData;
};

export default withUserData;
